









import Vue from "vue";
import { ScheduleConfiguration } from "@/model/data/scheduleSettings/ScheduleConfiguration";
import { ScheduleFrequencyEnum } from "@/model/data/scheduleSettings/ScheduleFrequencyEnum";
import { DayOfWeek } from "@/model/data/scheduleSettings/DayOfWeek";
import moment from "moment";
import { mapGetters } from "vuex";

export default Vue.extend({
    computed: {
        ...mapGetters(["userTimeFormat"]),
        scheduleText() {
            var currentSchedule = this.schedule as ScheduleConfiguration;
            switch (currentSchedule.frequency) {
                case ScheduleFrequencyEnum.Daily: {
                    return this.$t("scheduleConfiguration.dailyAt", {
                        time:
                            currentSchedule.time == null || currentSchedule.time == undefined
                                ? ""
                                : moment(currentSchedule.time as string, "HH:mm").format(this.userTimeFormat.timeFormat),
                    });
                }
                case ScheduleFrequencyEnum.Weekly: {
                    return this.$t("scheduleConfiguration.everyDayOfTheWeekAt", {
                        dayOfTheWeek: this.getDayOfWeekText(currentSchedule.days),
                        time:
                            currentSchedule.time == null || currentSchedule.time == undefined
                                ? ""
                                : moment(currentSchedule.time as string, "HH:mm").format(this.userTimeFormat.timeFormat),
                    });
                }
                case ScheduleFrequencyEnum.Monthly: {
                    return this.$t("scheduleConfiguration.occurenceOfDayOfWeekOfEveryMonthAt", {
                        monthOccurence: this.getMonthOccurenceText(currentSchedule.monthOccurence),
                        dayOfTheWeek: this.getDayOfWeekText(currentSchedule.days),
                        time:
                            currentSchedule.time == null || currentSchedule.time == undefined
                                ? ""
                                : moment(currentSchedule.time as string, "HH:mm").format(this.userTimeFormat.timeFormat),
                    });
                }
                default:
                    return this.$t("scheduleConfiguration.noScheduleConfiguration");
            }
        },
    },
    props: {
        schedule: Object as () => ScheduleConfiguration,
    },
    methods: {
        getDayOfWeekText(dayOfWeek: DayOfWeek) {
            switch (dayOfWeek) {
                case DayOfWeek.Monday:
                    return this.$t("common.dayOfWeek.monday");
                case DayOfWeek.Tuesday:
                    return this.$t("common.dayOfWeek.tuesday");
                case DayOfWeek.Wednesday:
                    return this.$t("common.dayOfWeek.wednesday");
                case DayOfWeek.Thursday:
                    return this.$t("common.dayOfWeek.thursday");
                case DayOfWeek.Friday:
                    return this.$t("common.dayOfWeek.friday");
                case DayOfWeek.Saturday:
                    return this.$t("common.dayOfWeek.saturday");
                case DayOfWeek.Sunday:
                    return this.$t("common.dayOfWeek.sunday");
                default:
                    return this.$t("common.unknown");
            }
        },
        getMonthOccurenceText(monthOccurence: number) {
            switch (monthOccurence) {
                case 0:
                    return this.$t("common.cardinal.first");
                case 1:
                    return this.$t("common.cardinal.second");
                case 2:
                    return this.$t("common.cardinal.third");
                case 3:
                    return this.$t("common.cardinal.fourth");
                case 4:
                    return this.$t("common.cardinal.last");
            }
        },
    },
});
